<template>
  <DataTable
    v-redirect-if-no-permission:CAR_BRANDS
    v-if="name"
    :url="api.ACTIONS.CAR_BRAND_MODELS(id)"
    :title="$t('catalogPage.brandModelsTitle', { name })"
    :fieldsHiddenMain="['deleted_at', 'car_brand_id', 'brand']"
    :fieldsHiddenAdd="['id', 'deleted_at', 'created_at', 'updated_at', 'car_brand_id', 'brand']"
    :fieldsHiddenEdit="['id', 'deleted_at', 'created_at', 'updated_at', 'car_brand_id', 'brand']"
    :fieldsExtraAdd="fieldsExtraAdd"
    :postExtraData="postExtraData"
    :editExtraData="editExtraData"
    :titles="titles"
    :formatter="formatter"
  ></DataTable>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";
import api from "@/constants/api.js";

export default {
  name: "CarBrandModels",
  title() {
    return this.$t("catalogPage.pageTitleModels");
  },
  components: { DataTable },
  data() {
    return {
      api,
      name: null,
      id: null,
      defaultItem: {
        name_en: "",
        name_ar: "",
      },
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.name = this.$route.query.name || this.$t("catalogPage.unknown");
  },
  computed: {
    titles() {
      return {
        id: "#",
        name_en: this.$t("catalogPage.colNameEn"),
        name_ar: this.$t("catalogPage.colNameAr"),
        created_at: this.$t("catalogPage.colDateCreated"),
        updated_at: this.$t("catalogPage.colDateUpdated"),
      };
    },
    fieldsExtraAdd() {
      return {
        name_en: "v-text-field",
        name_ar: "v-text-field",
      };
    },
    postExtraData() {
      return {
        car_brand_id: this.id,
      };
    },
    editExtraData() {
      return {
        car_brand_id: this.id,
      };
    },
    formatter() {
      const vm = this;
      return {
        created_at: (value) => {
          if (!value) return vm.$t("catalogPage.notAvailable");
          return formatCompanyTime(value, "YYYY-MM-DD");
        },
        updated_at: (value) => {
          if (!value) return vm.$t("catalogPage.notAvailable");
          return formatCompanyTime(value, "YYYY-MM-DD");
        },
      };
    },
  },
};
</script>

<style scoped></style>
